export const modesConstants = {

    GET_ALL_SUCCESS: "MODES_GET_ALL_SUCCESS",

    REQUEST: "MODES_REQUEST",
    FAILURE: "MODES_FAILURE",
};
